<template>
  <div v-if="$route.meta.headerCheckout !== false">

    <v-dialog 
    v-model="value"  
    width="600" 
    persistent 
    :fullscreen="!$mq.isDesktop()" 
    v-if="user && $route.path != '/' && $route.path != '/come-funziona' && $route.path != '/dal-produttore-al-consumatore' && $route.path != '/come-riciclare-la-tua-box'"
    >
    <v-card class="" v-if="user && user.subscription">

      <div
        class="flex pa-5 flex-vcenter"
        v-if="closable"
      >
        <h3 class='ma-0' style='margin: 0'>
          
        </h3>
        <span class="flex-grow-1" />
        <v-icon @click="value=false" large color="var(--quomi-primary)">fas fa-times-circle</v-icon>
      </div>


      <div>
        <div class="px-3 coverage">
          <v-stepper v-model="e1" class="elevation-0 pa-0">

          <v-stepper-items>
            <v-stepper-content class="pa-0" :step="1">

              <h3 class="text-center pa-5 text-title-big" style='color:inherit'> 
                Verifica la copertura della tua zona
              </h3>
              
              <v-alert color="" style='color: red' class=" pa-5 ma-5" v-if="coverage === false || unavailable">
                 Ci dispiace! Non serviamo ancora la tua zona! Scrivici a info@quomi.it o chiama lo 0280889266 per maggiori informazioni.
              </v-alert>

              <delivery-main :templates="configStep1">
                <template v-slot:cta-global v-if="$mq.isDesktop()">
                    <!--<CTA
                        :content="'Salva'"
                    />-->
                </template>
              </delivery-main>

              <CTA
                :disabled="!subscriptionStore.subscriptionParams.zip_code || !subscriptionStore.subscriptionParams.city"
                type="submit"
                content="Verifica copertura"
                :loading="loading"
                class="ma-auto my-4"
                @click="nextStep()"
              />
            </v-stepper-content>
            <v-stepper-content class="pa-0" :step="2">

              <h3 class="text-center pa-5 text-title-big" style='color:inherit'> 
                Scegli il giorno e l'orario, ti garantiremo i prodotti più freschi
              </h3>

              <div v-if="!loading">

              <div v-show="unavailable" class="">
              <v-alert color="" style='color: red' class=" pa-5">
                 Ci dispiace! Non serviamo ancora la tua zona! Scrivici a info@quomi.it o chiama lo 0280889266 per maggiori informazioni.
              </v-alert>
              </div>
              <div v-show="!unavailable">
                <delivery-main :templates="configStep2">
                  <template v-slot:cta-global v-if="$mq.isDesktop()">
                      <!--<CTA
                          :content="'Salva'"
                      />-->
                  </template>
                </delivery-main>

                  <CTA
                      :content="lastLabel"
                      isArrow
                      class="ma-auto my-4"
                      v-if="shipmentZonesStore.shipmentZones.loaded"
                      @click="update()"
                  />
                </div>
              </div>
              <div v-else>
                <loading-spin
                    :height='200'
                />
              </div>

            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <div class="pb-5 text-center " v-if="user.subscription.status == 'pending'">
          Sei già registrato? <span @click="openModal('signin')" class="text-bold login">Accedi</span>
        </div>
      </div>
    </div>
 
        <!--<div v-else class="pa-5">

          <auth
                :user="user"
                :showLogin="true"
                :showSignupLink="false"
            />

        </div>  -->

    </v-card>
  </v-dialog>
  </div>
</template>
<script>

import { ShipmentZonesApi } from '../../api/ShipmentZonesApi'
import DeliveryMain from '../Delivery/DeliveryMain'
import Auth from './Auth'
import { subscriptionStore } from '../../store/subscriptionStore'
import { shipmentZonesStore } from '../../store/shipmentZonesStore'
import { deliveryStore } from '../../store/deliveryStore'
import { menuStore } from '../../store/menuStore'
import { orderStore } from '../../store/orderStore'
import { errorStore } from '../../store/errorStore'
import { Order } from '../../core/Order'
import { deliveryContainer } from '../../mixins/deliveryContainer'
import { Repository } from '../../services/Repository'
import { stepStore } from '../../store/stepStore' 
import CheckoutChangeMenu from '../Delivery/CheckoutChangeMenu'

export default {
  components: {
    Auth,
    DeliveryMain,
    CheckoutChangeMenu
  },
  mixins: [
    deliveryContainer
  ],
  watch: {
    value: function (newVal) {
      if (!newVal) {
        this.closable = false;
      }
    }
  },
  computed: {
    isGuest () {
      return this.$root.user && this.$root.user.email.includes('guest.quomi.it')
    },
    address () {

        return this.delivery && this.deliveryStore.address
            && this.deliveryStore.address.delivery
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
    },

    delivery () {
        return this.deliveryStore
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
    },

    user() {
      return this.$root.user;
    },
    unavailable() {
      return this.shipmentZonesStore.shipmentZones.available.length == 0 && this.shipmentZonesStore.shipmentZones.loaded
    }
  },
  data () {
    return {
      closable: false,
      lastLabel: 'Prosegui',
      value: false,
      coverage: null,
      open: true,
      code: "",
      showLogin: false,
      loading: false,
      e1: 1,
      steps: 2,
      subscriptionStore: subscriptionStore.state,
      shipmentZonesStore: shipmentZonesStore.state,
      deliveryStore: deliveryStore.state,
      orderStore: orderStore.state,
      errorStore: errorStore.state,
      configStep1: [
          {
              name: 'standard',
              items: [
                  {
                      name: 'address',
                      label: 'Indirizzo di consegna',
                      price: '',
                      expanded: true,
                      enabled: ['city', 'zip_code']
                  }
              ]
          },
      ],
      configStep2: [
        {
          name: 'SelectShipmentDate',
            items: [
            {
                name: 'shipmentDay',
                label: 'Giorno di consegna',
                labelInactive: '',
                price: '',
                expanded: true
            },
            {
              name: 'timeRange',
              label: 'Seleziona una fascia oraria di consegna',
              labelInactive: 'Le fasce orarie saranno selezionabili prima della conferma dell\'ordine',
              price: '',
              expanded: true
            },  
          ]
        },
      ]
    }
  },
  methods: {
    openModal (target) {
      this.$parent.$emit('openModal', target)
      /* this.value = false; */
    },
    nextStep() {

      if (this.loading) {
        return;
      }

      if (this.unavailable) {
          return;
      }
      return this.isGuest ? this.update() : this.e1 = 2;
    },
    verify(code) {

      if (!code) {
        return;
      }

      this.loading = true;

      var dm = new ShipmentZonesApi()
      return dm.coverage({zip_code: code}).then(response => {
        this.lastLabel = 'Prosegui';
        this.coverage = response.body.data
        this.e1 = 2;
        this.loading = false
      })
    },

    update () {
      window.dispatchEvent(new CustomEvent('checkout-change-menu', { 
        bubbles: true,
        detail: this.updateZones
      }));
    },

    updateZones () {

      this.loading = true;
      return stepStore.updateShipmentZone().then(i => {
        return orderStore.updateOrder()
      }).then(i => {
          return menuStore.loadCurrentMenu(orderStore.state.order.week_plan.id)
      }).then(i => {

        window.dispatchEvent(new CustomEvent('checkout-menu-changed', { 
          bubbles: true,
        }));

        this.value = false;
        this.loading = false;
        this.e1 = 1;
      })
      
    }
  },
  mounted () {

    let rep = new Repository();
    menuStore.loadCurrentMenu().then(i => {
      if (menuStore.redirectHandler()) {
        throw "No menu"
      }
      return rep.retrieveOrCreateOrder()
    }).then(i => {
      subscriptionStore.state.subscription = this.user.subscription
      return this.$_deliveryContainer_fillSubscriptionParams()
    }).then(i => {
      if (!this.address) {
        this.value = true
      }
    }).finally(i => {
      
    })
  },
  created() {
    this.listener = (e) => {
      this.e1 = 2;
      this.value = e.detail;
      this.lastLabel = 'Salva';
      this.closable = true;
    };
    window.addEventListener('delivery-change', this.listener);
  },
  destroyed() {
    window.removeEventListener('delivery-change', this.listener);
  }
}
</script>
<style scoped>
  .coverage {
    font-size: 18px;
  }
  
  .coverage-detail {
    color: #575A5C;
    font-size: 14px;
    font-style: italic;
  }

  .login {
    color: var(--quomi-primary);
    cursor: pointer;
  }
</style>